import { v4 as uuid } from 'uuid';

export default [
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'West Virginia',
      city: 'Parkersburg',
      street: '2849 Fulton Street'
    },
    avatarUrl: '/static/images/avatars/avatar_3.png',
    createdAt: 1755016400000,
    email: 'ekaterina.tankova@gmail.com',
    name: 'Ekaterina2',
    phone: '304-428-3097',
    wallet: '123123123',
    vip: 'NOR',
    value: '100 BUSD',
  },
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'West Virginia',
      city: 'Parkersburg',
      street: '2849 Fulton Street'
    },
    avatarUrl: '/static/images/avatars/avatar_3.png',
    createdAt: 1255016400000,
    email: 'ekaterina.tankova@gmail.com',
    name: 'Ekaterina',
    phone: '304-428-3097',
    wallet: '123123123',
    vip: 'VIP',
    value: '12 BUSD',
  },
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'Bristow',
      city: 'Iowa',
      street: '1865  Pleasant Hill Road'
    },
    avatarUrl: '/static/images/avatars/avatar_4.png',
    createdAt: 1355016400000,
    email: 'cao.yu@gmail.com',
    name: 'Cao Yu',
    phone: '712-351-5711',
    wallet: '123123123',
    vip: 'NOR',
    value: '230 BUSD',
  },
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'Georgia',
      city: 'Atlanta',
      street: '4894  Lakeland Park Drive'
    },
    avatarUrl: '/static/images/avatars/avatar_2.png',
    createdAt: 1555016400000,
    email: 'alexa.richardson@gmail.com',
    name: 'Alexa Richardson',
    phone: '770-635-2682',
    wallet: '123123123',
    vip: 'NOR',
    value: '100 BUSD',
  },
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'Ohio',
      city: 'Dover',
      street: '4158  Hedge Street'
    },
    avatarUrl: '/static/images/avatars/avatar_5.png',
    createdAt: 1554930000000,
    email: 'anje.keizer@gmail.com',
    name: 'Anje Keizer',
    phone: '908-691-3242',
    wallet: '123123123',
    vip: 'VIP',
    value: '90 BUSD',
  },
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'Texas',
      city: 'Dallas',
      street: '75247'
    },
    avatarUrl: '/static/images/avatars/avatar_6.png',
    createdAt: 1154757200000,
    email: 'clarke.gillebert@gmail.com',
    name: 'Clarke Gillebert',
    phone: '972-333-4106',
    wallet: '123123123',
    vip: 'VIP',
    value: '1200 BUSD',
  },
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'California',
      city: 'Bakerfield',
      street: '317 Angus Road'
    },
    avatarUrl: '/static/images/avatars/avatar_1.png',
    createdAt: 1544670800000,
    email: 'adam.denisov@gmail.com',
    name: 'Adam Denisov',
    phone: '858-602-3409',
    wallet: '123123123',
    vip: 'VIP',
    value: '100 BUSD',
  },
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'California',
      city: 'Redondo Beach',
      street: '2188  Armbrester Drive'
    },
    avatarUrl: '/static/images/avatars/avatar_7.png',
    createdAt: 1554325200000,
    email: 'ava.gregoraci@gmail.com',
    name: 'Ava Gregoraci',
    phone: '415-907-2647',
    wallet: '123123123',
    vip: 'VIP',
    value: '100 BUSD',
  },
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'Nevada',
      city: 'Las Vegas',
      street: '1798  Hickory Ridge Drive'
    },
    avatarUrl: '/static/images/avatars/avatar_8.png',
    createdAt: 1523048400000,
    email: 'emilee.simchenko@gmail.com',
    name: 'Emilee Simchenko',
    phone: '702-661-1654',
    wallet: '123123123',
    vip: 'VIP',
    value: '100 BUSD',
  },
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'Michigan',
      city: 'Detroit',
      street: '3934  Wildrose Lane'
    },
    avatarUrl: '/static/images/avatars/avatar_9.png',
    createdAt: 1554702800000,
    email: 'kwak.seong.min@gmail.com',
    name: 'Kwak Seong-Min',
    phone: '313-812-8947',
    wallet: '123123123',
    vip: 'VIP',
    value: '100 BUSD',
  },
  {
    id: uuid(),
    address: {
      country: 'USA',
      state: 'Utah',
      city: 'Salt Lake City',
      street: '368 Lamberts Branch Road'
    },
    avatarUrl: '/static/images/avatars/avatar_10.png',
    createdAt: 1522702800000,
    email: 'merrile.burgett@gmail.com',
    name: 'Merrile Burgett',
    phone: '801-301-7894',
    wallet: '123123123',
    vip: 'VIP',
    value: '100 BUSD',
  }
];
